<template>
  <div :class="$options.name">
    <div
      :class="{
        [`${$options.name}__icon`]: true,
        [`${$options.name}__icon--hidden`]: !$slots['top-icon'] && type === 'empty',
        [`EdroneResultState__icon__${type}`]: true,
        [`${$options.name}__icon--custom`]: $slots['top-icon'],
      }"
    >
      <template v-if="type === 'loading'">
        <img alt="" src="https://d3vhsxl1pwzf0p.cloudfront.net/marketingmachine/edrone_loader.gif" />
      </template>

      <template v-else-if="type === 'successWithCaution'">
        <font-awesome-icon :icon="icon" />
        <div class="successWithCaution">
          <font-awesome-icon icon="fa-light fa-triangle-exclamation" />
        </div>
      </template>

      <!-- @slot Use this slot to provide custom icon. If you will not use this slot, the html content will have `display: none;` -->
      <slot v-else-if="type === 'empty'" name="top-icon" />

      <template v-else>
        <font-awesome-icon :icon="icon" />
      </template>
    </div>

    <!-- @slot Use this slot for a content inside the component, like text and buttons -->
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
export default defineComponent({
  name: "EdroneResultState",
  props: {
    type: {
      type: String as PropType<
        "info" | "caution" | "tip" | "error" | "success" | "successWithCaution" | "loading" | "empty"
      >,
      default: "info",
    },
  },
  setup(props) {
    const icon = computed(() => {
      switch (props.type) {
        case "info":
          return "fa-light fa-circle-info";
        case "caution":
          return "fa-light fa-triangle-exclamation";
        case "tip":
          return "fa-light fa-lightbulb";
        case "error":
          return "fa-light fa-octagon-exclamation";
        case "success":
          return "fa-light fa-circle-check";
        case "successWithCaution":
          return "fa-light fa-circle-check";
        default:
          return "fa-light fa-circle-info";
      }
    });

    return { icon };
  },
});
</script>

<style lang="scss" scoped>
.EdroneResultState {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  text-align: center;
  &__icon {
    width: 88px;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 42px;

    &--custom {
      margin-bottom: 0 !important;
    }

    &--hidden {
      display: none;
    }

    &__info {
      color: #050505;
      background: #fafafa;
      border: 1px solid #f2f2f2;
    }
    &__caution {
      color: #fdbf40;
      background: #fffcf5;
      border: 1px solid #fff2d9;
    }
    &__tip {
      color: #20a3f5;
      background: #ebf7fe;
      border: 1px solid #d2edfd;
    }
    &__error {
      color: #e50000;
      background: #fef6f6;
      border: 1px solid #facccc;
    }
    &__success {
      color: #00c672;
      background: #e6faf1;
      border: 1px solid #cdf4e4;
    }
    &__successWithCaution {
      color: #00c672;
      background: #e6faf1;
      border: 1px solid #cdf4e4;
    }
    &__loading {
      color: #050505;
      background: #fafafa;
      border: 1px solid #f2f2f2;
      img {
        width: 75%;
        height: 75%;
      }
    }
    &__empty {
      color: #050505;
      background: #fafafa;
      border: 1px solid #f2f2f2;
    }
    .successWithCaution {
      position: absolute;
      margin-left: 52px;
      margin-top: 52px;
      width: 56px;
      height: 56px;
      border-radius: 50%;

      border: 1px solid #fff2d9;
      background: #fffcf5;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 28px;
      color: #fdbf40;
    }
  }
}
</style>
